import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web'
import { ZoneContextManager } from '@opentelemetry/context-zone'
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { Resource } from '@opentelemetry/resources'
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base'
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web'
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions'

export const initSigNoz = () => {
  const { REACT_APP_STAGE, REACT_APP_SIGNOZ_SERVICE_NAME, REACT_APP_SIGNOZ_TOKEN } = process.env || window

  if (REACT_APP_STAGE && ['staging', 'production'].includes(REACT_APP_STAGE)) {
    const provider = new WebTracerProvider({
      resource: new Resource({
        [ATTR_SERVICE_NAME]: REACT_APP_SIGNOZ_SERVICE_NAME,
      }),
    })

    const exporter = new OTLPTraceExporter({
      url: 'https://ingest.us.signoz.cloud:443/v1/traces',
      headers: {
        'signoz-access-token': REACT_APP_SIGNOZ_TOKEN!,
      },
    })

    provider.addSpanProcessor(new BatchSpanProcessor(exporter))

    provider.register({
      // Changing default contextManager to use ZoneContextManager - supports asynchronous operations so that traces are not broken
      contextManager: new ZoneContextManager(),
    })

    // Registering instrumentations
    registerInstrumentations({
      instrumentations: [
        getWebAutoInstrumentations({
          '@opentelemetry/instrumentation-xml-http-request': {
            propagateTraceHeaderCorsUrls: [
              /.+/g, // Regex to match your backend URLs.
            ],
            ignoreUrls: [/algolia\.net/],
          },
          '@opentelemetry/instrumentation-fetch': {
            propagateTraceHeaderCorsUrls: [
              /.+/g, // Regex to match your backend URLs.
            ],
          },
        }),
      ],
    })
  }
}
